import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

//- Orange call-out used wherever an invoice's manual price is shown (invoice page, send dialog)
export const MANUAL_PRICE_ORANGE = '#E65100';
export const MANUAL_PRICE_BORDER = '#FF9800';
export const MANUAL_PRICE_BACKGROUND = '#FFF3E0';

//- Per gallon prices carry up to 5 decimals ($2.15, $1.20906)
const pricePerGallonFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2,
	maximumFractionDigits: 5,
});
export const formatPricePerGallon = (v) =>
	_.isNil(v) || !_.isFinite(parseFloat(v)) ? '-' : pricePerGallonFormatter.format(parseFloat(v));

const styles = () => ({
	box: {
		fontSize: 14,
		backgroundColor: MANUAL_PRICE_BACKGROUND,
		border: `1px solid ${MANUAL_PRICE_BORDER}`,
		borderRadius: 4,
		padding: '10px 15px',
		marginTop: 15,
		marginBottom: 15,
	},
	title: {
		fontWeight: 'bold',
		color: MANUAL_PRICE_ORANGE,
		marginBottom: 5,
	},
});

function ManualPriceNotice({ classes, title, children }) {
	return (
		<div className={classes.box}>
			<div className={classes.title}>{title}</div>
			{children}
		</div>
	);
}

ManualPriceNotice.propTypes = {
	classes: PropTypes.object.isRequired,
	title: PropTypes.node.isRequired,
	children: PropTypes.node,
};

export default withStyles(styles)(ManualPriceNotice);
